import { gql } from '@apollo/client';

export const GET_SITES_QUERY = gql`
  query getSitesQuery($group_id: String, $company_id: String) {
    sites(group_id: $group_id, company_id: $company_id) {
      id
      deleted
      name
      subdivision {
        id
        name
        division {
          id
          name
        }
      }
      region {
        id
        name
      }
      archived
      latitude
      longitude
      glo_id
      reference {
        id
        path
        parentPath
      }
    }
  }
`;

export const ALLOW_DELETE_SITE_QUERY = gql`
  query allowDeleteSiteQuery($group_id: String, $company_id: String, $site_id: String) {
    allowDeleteSite(group_id: $group_id, company_id: $company_id, site_id: $site_id)
  }
`;
